<template>
  <div class="video-ptz_wrap">
    <div class="control_panel">
      <div class="control-panel_left">
        <ul class="cloud-handel">
          <div class="panel_li">
            <li
              v-for="item in ctrlArray"
              :key="item.title"
              :title="item.title"
              @mousedown="handleCloudControl(item.value, 1)"
              @mouseup="handleCloudControl(item.value, 2)"
            >
              <img src="@src/common/assets/images/ptz-bg.png" alt="" />
              <span class="icon iconfont-lunan icon-lunan-xiaosanjiaoup"></span>
            </li>
            <div
              class="reset"
              @mousedown="handleCloudControl(0x0402, 1)"
              @mouseup="handleCloudControl(0x0402, 2)"
            >
              <i class="el-icon-refresh" title="重置"></i>
            </div>
          </div>
        </ul>
      </div>
      <div class="control-panel_right">
        <div class="right-row">
          <div class="right-row_ico">
            <i
              title="光圈开"
              class="icon iconfont-add iconguangquan"
              @mousedown="handleCloudControl(0x0104, 1)"
              @mouseup="handleCloudControl(0x0104, 2)"
            ></i>
          </div>
          <div class="right-row_label">光圈</div>
          <div class="right-row_ico">
            <i
              title="光圈关"
              class="icon iconfont-add iconguangquan-"
              @mousedown="handleCloudControl(0x0101, 1)"
              @mouseup="handleCloudControl(0x0101, 2)"
            ></i>
          </div>
        </div>
        <div class="right-row">
          <div class="right-row_ico">
            <i
              title="聚焦近"
              class="icon iconfont-add iconweiju"
              @mousedown="handleCloudControl(0x0202, 1)"
              @mouseup="handleCloudControl(0x0202, 2)"
            ></i>
          </div>
          <div class="right-row_label">聚焦</div>
          <div class="right-row_ico">
            <i
              @mousedown="handleCloudControl(0x0204, 1)"
              @mouseup="handleCloudControl(0x0204, 2)"
              class="icon iconfont-add iconyuanjing"
              title="聚焦远"
            ></i>
          </div>
        </div>
        <div class="right-row">
          <div class="right-row_ico">
            <i
              @mousedown="handleCloudControl(0x0302, 1)"
              @mouseup="handleCloudControl(0x0302, 2)"
              class="icon iconfont-add iconfangda"
              title="焦距放大"
            ></i>
          </div>
          <div class="right-row_label">焦距</div>
          <div class="right-row_ico">
            <i
              @mousedown="handleCloudControl(0x0304, 1)"
              @mouseup="handleCloudControl(0x0304, 2)"
              class="icon iconfont-add iconsuoxiao"
              title="焦距缩小"
            ></i>
          </div>
        </div>
      </div>
    </div>
    <div class="control-panel_bar">
      云台速度：
      <span style="margin-right: 10px" @click="speed--">
        <i class="el-icon-minus"></i>
      </span>
      <el-slider
        style="width: 55%"
        v-model="speed"
        :step="1"
        :min="1"
        :max="9"
      ></el-slider>
      <span style="margin-left: 8px" @click="speed++">
        <i class="el-icon-plus"></i>
      </span>
    </div>
  </div>
</template>

<script>
import busVue from "@/common/utils/busVue";
export default {
  data() {
    return {
      speed: 1,
      setActionTime: 0,
      setTime: "",
      ctrlArray: [
        { title: "上", value: 0x0402 },
        { title: "右上", value: 0x0802 },
        { title: "右", value: 0x0502 },
        { title: "右下", value: 0x0804 },
        { title: "下", value: 0x0404 },
        { title: "左下", value: 0x0704 },
        { title: "左", value: 0x0504 },
        { title: "左上", value: 0x0702 },
      ],
    };
  },
  created() {},
  mounted() {},
  methods: {
    // 云台控制,该位置应该配置节流,防止重复点击
    // 1鼠標按下執行 2鼠標抬起執行
    handleCloudControl(optCode, modeCode) {
      if (this.setTime) {
        this.setActionTime = 0;
        clearInterval(this.setTime);
      }
      this.setTime = setInterval(() => {
        this.setActionTime++;
        if (this.setActionTime > 3) {
          let ctrlOption = {
            modeCode: modeCode || '',
            optCode: optCode,
            speed: this.speed,
            callBack: this.handlePlayCtrlCallBack,
          };
          busVue.$emit("handlePtzCamera", ctrlOption);
          this.setActionTime = 0;
          clearInterval(this.setTime);
        }
      }, 300);
    },
    // 云台控制回调
    handlePlayCtrlCallBack() {
      console.log("操作成功");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";

.video-ptz_wrap {
  padding: 12px 16px;
  position: relative;
  width: 100%;
  height: 100%;
  @include set_theme_color(background-color, left-menu-bg-color);

  .control_panel {
    display: flex;
    justify-content: space-between;
    position: relative;

    .control-panel_right {
      display: flex;
      flex-direction: column;

      .right-row {
        display: inline-flex;
        height: 50px;
        line-height: 50px;

        .right-row_label {
          margin: 0 12px;
        }

        .right-row_ico {
          cursor: pointer;

          i {
            font-size: 20px !important;
          }

          &:hover {
            color: #407aee;
          }
        }
      }
    }
  }

  .control-panel_bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;

    i {
      cursor: pointer;

      &:hover {
        color: #407aee;
      }
    }
  }

  .cloud-handel {
    left: 40px;
    top: 45px;
    width: 60px;
    height: 60px;
    border-radius: 30px;
    position: absolute;
    color: rgb(139, 142, 152);

    .panel_li {
      position: relative;
      width: 100%;
      height: 100%;

      li {
        cursor: pointer;
        position: absolute;
        background-size: 100% 100%;

        span {
          position: absolute;
          top: 10px;
          right: 17px;
          color: #fff;
        }

        &:hover {
          span {
            color: #407aee !important;
          }
        }

        &:first-child {
          right: 0px;
          top: -35px;
        }

        &:nth-child(2) {
          right: -35px;
          top: -20px;
          transform: rotate(45deg);
        }

        &:nth-child(3) {
          right: -50px;
          top: 15px;
          transform: rotate(90deg);
        }

        &:nth-child(4) {
          bottom: -30px;
          right: -35px;
          transform: rotate(135deg);
        }

        &:nth-child(5) {
          left: 10px;
          bottom: -45px;
          transform: rotate(180deg);
        }

        &:nth-child(6) {
          bottom: -30px;
          left: -25px;
          transform: rotate(-135deg);
        }

        &:nth-child(7) {
          left: -40px;
          top: 15px;
          transform: rotate(-90deg);
        }

        &:nth-child(8) {
          left: -25px;
          top: -20px;
          transform: rotate(-45deg);
        }
      }

      .middle {
        left: 17px;
        top: 17px;
      }

      .middle-pause {
        width: 25px;
        height: 25px;
        right: 15.5px;
        border-radius: 5px;
        background: rgb(139, 142, 152);
      }

      .middle-pause:hover {
        background: rgba(64, 122, 238, 1);
      }

      // &:last-child {
      //     left: 89px;
      //     top: 33px;
      //     transform: rotate(45deg);
      // }
    }

    .reset {
      width: 55px;
      height: 55px;
      background: #262b37;
      border-radius: 50%;
      position: absolute;
      left: 12%;
      top: 11%;
      text-align: center;
      line-height: 55px;
      font-size: 28px;
      cursor: pointer;

      &:hover {
        color: #407aee;
      }
    }
  }
}
</style>
